<template>
  <el-drawer title="发起审批" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-form ref="addForm" status-icon :model="addForm" :rules="rules" label-position="left" label-width="83px" size="small" class="mx-20-1 bg-#fff py-20 pr-30">
      <el-form-item label="报销类别：" prop="reimbursementType">
        <el-select v-model="addForm.reimbursementType" filterable clearable value-key="reimbursementType" placeholder="选择报销类别" style="width: 100%">
          <el-option
            v-for="item in reimbursementTypeLists"
            :key="item.reimbursementTypeId"
            :label="item.reimbursementTypeName"
            :value="{ reimbursementType: item.reimbursementTypeId, reimbursementTypeName: item.reimbursementTypeName }"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="报销事由：" prop="reimbursementReason">
        <el-input
          v-angle="addForm.reimbursementReason"
          v-model="addForm.reimbursementReason"
          placeholder="填写报销事由"
          :rows="4"
          maxlength="70"
          type="textarea"
          show-word-limit
          clearable
        />
      </el-form-item>
      <el-form-item label="报销总额：" prop="reimbursementAmount">
        <el-input v-angle="addForm.reimbursementAmount" v-model="addForm.reimbursementAmount" disabled placeholder="根据报销明细，系统自动计算" clearable />
      </el-form-item>
      <template>
        <div class="form-Title">报销明细</div>
        <template v-if="addForm.flowReimbursementItems && addForm.flowReimbursementItems.length">
          <div v-for="(item, index) in addForm.flowReimbursementItems" :key="index" class="box">
            <div class="mb-17 flex align-center justify-between">
              <div class="title">报销明细{{ index + 1 }}</div>
              <div v-if="index !== 0" class="delete" @click="deleteItem(index)">删除</div>
            </div>
            <el-form-item label="费用说明：" :prop="`flowReimbursementItems.${index}.reimbursementItem`" :rules="rules.reimbursementItem">
              <el-input v-angle="item.reimbursementItem" v-model="item.reimbursementItem" placeholder="填写费用说明" maxlength="14" show-word-limit clearable />
            </el-form-item>
            <el-form-item label="发生日期：" :prop="`flowReimbursementItems.${index}.feeDate`" :rules="rules.feeDate">
              <el-date-picker v-model="item.feeDate" type="date" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择费用发生日期" style="width: 100%"></el-date-picker>
            </el-form-item>
            <el-form-item label="报销金额：" :prop="`flowReimbursementItems.${index}.itemAmount`" :rules="rules.itemAmount" class="el-form-flex">
              <el-input
                v-angle="item.itemAmount"
                v-model="item.itemAmount"
                oninput="value=value.replace(/^(\-?\d*\.?\d{0,2})?.*$/,'$1')"
                placeholder="请填写报销金额"
                clearable
                class="flex-1"
                @change="amountChange"
              />
              <span class="ml-16">元</span>
            </el-form-item>
            <el-form-item label="附件：" :prop="`flowReimbursementItems.${index}.annexUrl`" :rules="rules.annexUrl">
              <el-upload
                class="flex items-start flex-column"
                accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf"
                :action="`/api/estate/v1/common/uploadFile?token=${token}&communityId=0`"
                :on-success="(response, file, fileList) => handleSuccess(response, file, fileList, index)"
                :on-remove="(file, fileList) => handleRemove(file, fileList, index)"
                multiple
                :limit="1"
              >
                <el-button size="small" type="primary" class="mr-8">选择附件</el-button>
              </el-upload>
              <div class="el-upload__tip">不超过2M，格式为jpg/jpeg/png/doc/docx/xls/xlsx/pdf</div>
            </el-form-item>
          </div>
        </template>
        <div class="addBtn" @click="add">+ 添加报销</div>
      </template>
    </el-form>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { getToken } from '@/utils/auth'
import { submitFlowReimbursementApply } from '@/api/workflow'
import { reimbursementTypeDropList } from '@/api/dropList'
import formatData from '@/utils/formatRequestData'

export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      addForm: {
        reimbursementType: '',
        reimbursementTypeName: '',
        reimbursementReason: '',
        reimbursementAmount: '',
        flowReimbursementItems: [{ reimbursementItem: '', feeDate: '', itemAmount: '', annexUrl: [] }],
      },
      fileList: [],
      rules: {
        reimbursementType: [{ required: true, message: '报销类别不能为空', trigger: 'change' }],
        reimbursementReason: [{ required: true, message: '报销事由不能为空', trigger: 'change' }],
        reimbursementItem: [{ required: true, message: '费用说明不能为空', trigger: 'change' }],
        feeDate: [{ required: true, message: '发生日期不能为空', trigger: 'change' }],
        itemAmount: [{ required: true, message: '报销金额不能为空', trigger: 'change' }],
        annexUrl: [{ required: true, message: '附件不能为空', trigger: 'change' }],
        reimbursementAmount: [{ required: true, message: '报销总额不能为空', trigger: 'change' }],
      },
      reimbursementTypeLists: [],
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        this.getReimbursementTypeDropList()
      }
    },
  },
  computed: {
    token() {
      return getToken()
    },
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const format = formatData(this.addForm)
      const { data: res } = await submitFlowReimbursementApply({
        flowReimbursementItems: this.addForm.flowReimbursementItems,
        flowReimbursementDetail: {
          reimbursementType: format.reimbursementType,
          reimbursementTypeName: format.reimbursementTypeName,
          reimbursementReason: format.reimbursementReason,
          reimbursementAmount: format.reimbursementAmount,
        },
      })

      if (!res) return this.$message.error('发起失败')
      this.$message.success('发起成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },

    // 添加报销
    add() {
      this.addForm.flowReimbursementItems.push({ reimbursementItem: '', feeDate: '', itemAmount: '', annexUrl: [] })
    },

    // 删除报销明细
    deleteItem(index) {
      this.addForm.flowReimbursementItems.splice(index, 1)
    },

    // 报销金额
    amountChange() {
      let total = 0
      this.addForm.flowReimbursementItems.map(item => {
        if (item.itemAmount) total += Number(item.itemAmount)
      })
      this.addForm.reimbursementAmount = total ? total.toFixed(2) : ''
    },

    // 移除上传的文件
    handleRemove(file, fileList, index) {
      this.addForm.flowReimbursementItems[index].annexUrl = fileList.map(item => item.response.data.visitUrl)
    },

    handleSuccess(res, file, fileList, index) {
      if (res.errCode !== 0) {
        this.handleRemove(file, fileList, index)
        return this.$message.error(res.errMsg)
      }
      this.addForm.flowReimbursementItems[index].annexUrl = fileList.map(item => item.response.data.visitUrl)
    },

    async getReimbursementTypeDropList() {
      const { data } = await reimbursementTypeDropList()
      this.reimbursementTypeLists = data || []
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  border-radius: 8px;
  padding: 16px;
  background: #f7f8fa;
  margin-bottom: 16px;
  .delete {
    color: #fa0000;
    font-size: 14px;
    cursor: pointer;
  }
  .title {
    color: #1a1a1a;
    font-size: 14px;
    font-weight: bold;
  }
}
.mb-17 {
  margin-bottom: 17px;
}
.addBtn {
  width: 100%;
  background: #f7f8fa;
  border-radius: 4px;
  padding: 12px;
  text-align: center;
  color: #31a8ff;
  font-size: 14px;
  cursor: pointer;
}
.ml-16 {
  margin-left: 16px;
}
::v-deep .el-upload {
  width: auto !important;
  height: auto !important;
  border: none !important;
}
.el-upload__tip {
  color: #606266 !important;
  margin-top: 0 !important;
}
</style>
